import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "#444545",
  "stroke-linecap": "round",
  "stroke-width": "3",
  viewBox: "0 0 240 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M237.5 1.5H1.5v236h236z" }, null, -1),
    _createElementVNode("path", { d: "M237.5 194.578c-40.437 0-35.607-73.974-66.798-110.27C118.257 23.03 44.422 58.636 44.422 1.5M1.5 194.578c56.17 0 102.267-90.121 122.968-26.774 18.632 57.137 70.249 29.81 70.249 69.558M1.5 44.422c68.868-2.484 119.518 22.91 124.486 55.894 7.315 48.58-81.564 83.498-81.564 137.184M237.5 44.422c-9.385 0-14.905 1.104-24.842-5.935-17.114-12.145-18.08-23.876-18.08-36.987" }, null, -1)
  ])))
}
export default { render: render }